module.exports = "/assets/879b530d554aad698dedc6f68162a538.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MF.png
// module id = 2736
// module chunks = 0